

import React, { memo } from 'react';
import { ApolloConsumer } from 'react-apollo';
import { UploaderConsumer } from '../../Uploader';
import ManageAssetModalComponent from '../components/ManageAssetModal';








function ManageAssetModal(props) {
  return (
    <ApolloConsumer>
      {(apolloClient) =>
      <UploaderConsumer>
          {({ updateAsset }) =>
        <ManageAssetModalComponent
          {...props}
          apiClient={apolloClient}
          updateAsset={updateAsset} />}


        </UploaderConsumer>}

    </ApolloConsumer>);

}

export default memo(ManageAssetModal);